<template>
  <v-dialog v-model="dialog" width="300" @input="onClick()">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="twelveHourTime"
        :label="label"
        readonly
        v-bind="attrs"
        :data-cy="dataCy"
        v-on="on"
      />
    </template>
    <div>
      <v-time-picker
        ref="picker"
        :class="dynamicClass()"
        v-model="placeholder"
        ampm-in-title
        :allowed-minutes="allowedMinutes()"
        style="border-radius: 0; width: 100%"
        @input="(val) => $emit('input', val)"
      />
      <v-btn
        style="border-radius: 0; width: 100%"
        :data-cy="`${dataCy}-button-submit`"
        @click="dialog = false"
      >
        Done
      </v-btn>
    </div>
  </v-dialog>
</template>

<style scoped>
.force-not-disabled >>> .v-time-picker-clock__item--disabled {
  color: rgba(0, 0, 0, 1);
}
</style>

<script>
import { DateTime } from "luxon";

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    timeIncrement: {
      type: String,
      default: "15 Minute Increment",
    },
    label: {
      type: String,
      default: null,
    },
    dataCy: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    twelveHourTime() {
      return this.value
        ? DateTime.fromFormat(this.value, "HH:mm").toFormat("hh:mm a")
        : "";
    },
    placeholder: {
      set() {
        return this.value;
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    onClick() {
      this.$nextTick(() => {
        this.$refs.picker.selectingHour = true;
      });
    },
    allowedMinutes() {
      if (this.timeIncrement.includes("15")) {
        return [0, 15, 30, 45];
      } else if (this.timeIncrement.includes("10")) {
        return [0, 10, 20, 30, 40, 50];
      } else {
        return [0, 6, 12, 18, 24, 30, 36, 42, 48, 54, 0];
      }
    },
    dynamicClass() {
      return this.timeIncrement.includes("6") ? "force-not-disabled" : "";
    },
  },
};
</script>

